import {gql, useSubscription} from "@apollo/client";
import {Result, Table, Typography} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {流程} from "./config";
import {useEffect, useState} from "react";

const {Title} = Typography;

export default function Home(props) {
    const [userId, setUserId] = useState('')
    const [mndsbObj, setMndsbObj] = useState({})
    const logto = props.logto
    const mndsbColumns = [
        {
            title: '公司名称',
            dataIndex: 'companyObj',
            key: 'companyObj',
            render: (_, record) => _.qymc,
        },
        {
            title: '申报年度',
            dataIndex: 'year',
            key: 'year',
        },
        {
            title: '申报时间',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_, record) => new Date(_).toLocaleString(),
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/sbnr?' + _
                }}>申报内容</a>
            ),
        },
    ];
    const {data: serverData} = useSubscription(
        gql`subscription MySubscription {
            server {
                updated_at
                person
                name
                id
                enable
                created_at
            }
        }`, {
            // variables: {company: value},
            shouldResubscribe: true
        },
    );
    const {data: mndsbData, loading: mndsbDataLoading} = useSubscription(
        gql`
            subscription MySubscription($server: String = "") {
                mndsb(where: {server: {_eq: $server}}, order_by: {created_at: asc}) {
                    companyObj {
                        updated_at
                        tyshxydm
                        qymc
                        qyjj
                        qyjc
                        owner
                        id
                        created_at
                        clsj
                    }
                    process(order_by: {created_at: desc}, limit: 1) {
                        comment
                        created_at
                        id
                        mndsb
                        name
                        operator
                        passed
                        updated_at
                        type
                    }
                    id
                    year
                    created_at
                }
            }
        `, {
            variables: {server: userId},
            shouldResubscribe: true
        },
    );
    useEffect(() => {
        if (mndsbData) {
            const obj = {}
            mndsbData.mndsb.map(m => {
                if (m.process.length > 0) {
                    if (obj[m.process[0].name]) {
                        obj[m.process[0].name].push(m)
                    } else {
                        obj[m.process[0].name] = [m]
                    }
                } else {
                    if (obj['企业基本信息填写']) {
                        obj['企业基本信息填写'].push(m)
                    } else {
                        obj['企业基本信息填写'] = [m]
                    }
                }
            })
            setMndsbObj(obj)
        }
    }, [mndsbData])
    useEffect(() => {
        logto.fetchUserInfo().then(userInfo => {
            setUserId(userInfo.sub)
        })
    }, [])
    return (
        <>
            {(serverData || {server: []}).server.length === 0 && <>
                <div style={{padding: '10px'}}></div>
                <Result
                    icon={<InfoCircleOutlined/>}
                    title="访问受限"
                    subTitle="请联系我们为您开通相应访问权限"

                    // extra={<Button type="primary">Next</Button>}
                    // extra={<text style={{fontSize:'18px'}}>请耐心等待</text>}
                />
            </>}
            {(serverData || {server: []}).server.length > 0 && <>
                {流程.map(p => <>
                        <Title level={3}>{p}</Title>
                        <Table columns={mndsbColumns} dataSource={(mndsbObj || {})[p]}/>
                    </>
                )}
            </>}
        </>
    )
}
